// ============================================================================
// Action bar de entidade (regra FC7 §G.7 — .claude/rules/fc7-design-system.md).
//
// Barra de ações de telas de detalhe/edição de entidade (billing, product,
// movement, employee...). Ratificada em 2026-07-03:
//
//   - PORTE TOOLBAR: a barra impõe 31px / radius 8 / font 11.5 a qualquer
//     botão ou link do kit dentro dela — o call site NÃO declara porte.
//     (Reduzido ~15% de 36/13 em 2026-07-03, pedido do Caio.)
//   - ORDEM CANÔNICA (esquerda → direita): destrutivo ISOLADO na ponta
//     esquerda (com <ActionBarSpacer/> depois dele) · consultivos/navegação ·
//     ação principal do modo SEMPRE na ponta direita.
//       visualização:  [Excluir]        [Novo] [Ver X] [Editar]
//       edição:                         [ações] [Cancelar] [Salvar]
//   - Sem destrutivo → sem spacer; tudo alinha à direita.
//
// Uso: substitui o <PageHeaderActions> nas telas de entidade (é um superset:
// flex + wrap + gap + porte). Botões continuam vindo de styles/ui/Button.js —
// a semântica de cor (G.1) não muda aqui, só o porte e a ordem.
// ============================================================================
import styled from 'styled-components';

export const EntityActionBar = styled.div`
   display: flex;
   align-items: center;
   justify-content: flex-end;
   gap: 8px;
   flex-wrap: wrap;

   /* Porte toolbar — vence a geometria padrão do kit por especificidade
      (classe + elemento). Cores/estados continuam do kit. */
   > button,
   > a {
      height: 31px;
      padding: 0 12px;
      border-radius: 8px;
      font-size: 11.5px;
   }
`;

// Isola o bloco destrutivo na ponta esquerda: renderizar logo após o(s)
// botão(ões) danger. Some no wrap do mobile sem quebrar o layout.
export const ActionBarSpacer = styled.span`
   flex: 1 1 24px;
   min-width: 24px;
`;
